import { render, staticRenderFns } from "./TicketRecipients.vue?vue&type=template&id=fab3bd52&"
import script from "./TicketRecipients.vue?vue&type=script&lang=js&"
export * from "./TicketRecipients.vue?vue&type=script&lang=js&"
import style0 from "./TicketRecipients.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports